import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Table, Badge, Button, Tag , Divider, Icon} from 'antd';
import RecordAddForm from './RecordAddForm';
import { recordsAddModalOpen, recordsEditModalOpen, recordKeyCopyToClipboardSuccess } from '../../actions/recordsActions';
import RecordAddFormModal from './RecordAddFormModal';
import RecordEditFormModal from './RecordEditFormModal';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class Records extends Component{
    needGenerateButton(){
        if(this.props.records.length === 0)
            return false
            
        return !this.props.records.every((item)=>item.coincidence !=100)
    }

    render() {
        let userFilter = [];
        let alreadyAdded = [];

        this.props.records.map((item)=>{
            if(!item.user)
                return;

            if(alreadyAdded.indexOf(item.user.username) === -1){
                userFilter.push({text:item.user.username,value:item.user.username});             
                alreadyAdded.push(item.user.username);
            }
        });

        const columns = [{
            title: 'HID',
            dataIndex: 'hid',
            key: 'hid',
            width: '200px',
            render: (hid, record) => (
                <div>
                    {(this.props.auth.admin == 'Y'
                        ? (<a href={"javascript:;"} onClick={this.props.recordsEditModalOpen.bind(this, record)}><Icon type="edit" theme="filled" /> {hid}</a>) 
                        : hid
                    )}                
                </div>
            )
          }, 
          {
            title: 'Незашифрованный HID',
            dataIndex: 'server_article',
            key: 'server_article',
            width: '250px',
            render: (server_article, record) => (
                (server_article.map((item,i)=>{
                    return <div key={i}><Tag color={(item.coincidence 
                        ? "green"
                        : (item.check_coincidence ? "red" : "grey")
                    )} 
                    key={i}>{item.label+": "+item.article_part}</Tag>

                    {(record.server_article_requested && !item.coincidence && item.check_coincidence
                        ? (<Tag color="green">->{record.server_article_requested.split('-')[i]}</Tag>) 
                        : null
                    )}

                    </div>
                }))
            )
          },          
          {
            title: '% совпадения HID',
            dataIndex: 'coincidence',
            key: 'coincidence',
            width: '200px',
	    defaultSortOrder: 'descend',
            sorter: (a, b) => a.coincidence - b.coincidence,
            render: (text, record) => (
                record.coincidence != '100' && record.server_article.some(item=>item.check_coincidence) && this.props.records.every((item)=>item.coincidence !=100)
                ?   <div>
                        <Button 
                            size="small" 
                            type="danger"
                            htmlType="submit" 
                            onClick={this.props.recordsAddModalOpen.bind(this, {
                                hidden_data: true,
                                hid: this.props.record_search_form.hid,
                                serial_number: record.serial_number
                            })}
                        >
                        {text+'% сгенерировать новый ключ'}
                        </Button>
                    </div>
                :   (
                        text !='-' 
                        ? (record.coincidence == '100' 
                            ? <Badge count={text+'%'} style={{ backgroundColor: '#52c41a' }} /> 
                            : <Badge count={text+'%'}  />
                        )
                        : '-'
                    )
            )
          },
          {
            title: 'Серийный',
            dataIndex: 'serial_number',
            key: 'serial_number',
          },{
            title: 'Ключ',
            dataIndex: 'key',
            key: 'key',
            width: '100px',
            render: (key, record) => (
                <CopyToClipboard text={key} onCopy={this.props.recordKeyCopyToClipboardSuccess.bind(this, {key:key})}>
                    <Button type='dashed' style={{color: 'green'}} icon="copy">копировать ключ</Button>
                </CopyToClipboard>
            )
          }, {
            title: 'Кто активировал',
            dataIndex: 'user.username',
            key: 'user.username',
            filters: userFilter,
            onFilter: (value, record) => record.user.username.indexOf(value) === 0,
            render: (date, record) => (
                <span>
                    {
                    ('user_update' in record) 
                        ? <div><Tag color="red">{record.user.username}</Tag><Tag color="green">-->{record.user_update.username}</Tag></div> 
                        : <div>{record.user.username}</div>
                    }
                </span>
            )
          }, {
            title: 'Дата активации',
            dataIndex: 'date',
            key: 'date',
            sorter: (a, b) => new Date(a.date) - new Date(b.date),
            render: (date, record) => (
                <span>
                    {
                    ('date_update' in record && record.date_update !== null) 
                        ? <div><Tag color="red">{date.split('.')[0].replace('T', ' ')}</Tag><Tag color="green">-->{record.date_update.split('.')[0].replace('T', ' ')}</Tag></div>
                        : <div>{date.split('.')[0].replace('T', ' ')}</div>
                    }
                </span>
            )
          },  {
            title: 'Комментарий',
            dataIndex: 'comments',
            key: 'comments',
          }
        ];

        return ( 
            <div>
                {(this.props.records && this.props.records.length > 0) ? <div><Table  columns={columns}  dataSource={this.props.records} /></div> : <div></div>}
                <RecordAddFormModal />
                <RecordEditFormModal />
            </div>
        )
    }    
}

const mapStateToProps = state => ({
    records: state.records.records,
    record_search_form: state.records.record_search_form,
    record_add_modal: state.records.record_add_modal,
    auth: state.auth
})

const mapDispatchToProps = dispatch => ({
    recordsAddModalOpen: payload => dispatch(recordsAddModalOpen(payload)),
    recordsEditModalOpen: payload => dispatch(recordsEditModalOpen(payload)),
    recordKeyCopyToClipboardSuccess: payload => dispatch(recordKeyCopyToClipboardSuccess(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Records);



// WEBPACK FOOTER //
// ./src/components/containers/Records.js